import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "relative h-full" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 4,
  class: "view-mode-item-container"
}
const _hoisted_5 = { class: "flex flex-col lg:flex-row w-screen relative" }
const _hoisted_6 = { class: "bg-white lg:hidden border-b border-t border-gray-200 py-2 px-4 flex justify-between" }
const _hoisted_7 = {
  key: 0,
  class: "text-xl tracking-tight text-gray-900"
}
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = { class: "sticky top-32 z-10" }
const _hoisted_13 = { class: "grow text-base tracking-tight text-gray-900 sm:text-2xl sm:pr-14 font-ivymode" }
const _hoisted_14 = { class: "hidden sm:flex w-full items-center justify-start gap-x-2 mt-2" }
const _hoisted_15 = {
  key: 0,
  class: "text-2xl tracking-tight text-gray-900 mb-2 text-right italic"
}
const _hoisted_16 = { class: "ml-2 text-base text-brand-main font-light" }
const _hoisted_17 = { class: "hidden lg:flex space-x-2" }
const _hoisted_18 = { class: "rounded-full bg-brand-main w-9 h-9 text-white flex justify-center items-center" }
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = { class: "w-9 h-9 text-white flex justify-center items-center" }
const _hoisted_21 = {
  key: 0,
  class: "hidden sm:flex w-24 h-full content-center"
}
const _hoisted_22 = {
  key: 0,
  class: "px-4 xl:flex py-4"
}
const _hoisted_23 = {
  key: 1,
  class: "block space-y-4 w-screen px-4 md:w-full pb-4"
}
const _hoisted_24 = { class: "grow" }
const _hoisted_25 = { class: "font-bold block text-black pr-1 text-xs" }
const _hoisted_26 = { class: "shrink-0 w-6 cursor-pointer text-brand-main" }
const _hoisted_27 = {
  key: 0,
  class: "block space-y-4 w-screen px-4 md:w-full mt-4 border-b border-gray-100 pb-4"
}
const _hoisted_28 = { class: "grow" }
const _hoisted_29 = { class: "font-bold block text-black pr-1 text-xs" }
const _hoisted_30 = { class: "lex-shrink-0 w-6 cursor-pointer text-brand-main" }
const _hoisted_31 = { class: "my-4 space-y-4 w-full px-4" }
const _hoisted_32 = { class: "my-4 space-y-4 w-full px-4 border-brand-main border-t pt-4" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 0,
  class: "block w-full text-white bg-brand-main opacity-50 p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
}
const _hoisted_35 = {
  href: "/partner",
  class: "block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
}
const _hoisted_36 = ["action"]
const _hoisted_37 = ["value"]
const _hoisted_38 = ["value"]
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "w-screen relative" }

import {computed, nextTick, onMounted, onUnmounted, provide, ref, watch} from "vue";
import {useI18n} from "vue-i18n";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {Sessions} from "@/assets/ts/sessions";
import DescriptionParts from "@/components/description/descriptionParts.vue";
import ItemV2ImageGrid from "@/components/itemV2/itemV2ImageGrid.vue";
import ItemV3ImageGridWeddingRings from "@/components/itemV3/itemV3ImageGridWeddingRings.vue";
import ItemV2Variants from "@/components/itemV2/itemV2Variants.vue";
import ItemV3VariantsConf from "@/components/itemV3/itemV3VariantsConf.vue";
import ItemV2Engraving from "@/components/itemV2/itemV2Engraving.vue";
import ItemV2StoneType from "@/components/itemV2/itemV2StoneType.vue";
import ItemV2ShopTheLook from "@/components/itemV2/itemV2ShopTheLook.vue";
import ItemV2Name from "@/components/itemV2/itemV2Name.vue";
import StepWidget from "@/components/stepWidget.vue";
import StepWidgetConf from "@/components/stepWidgetConf.vue";
import ItemV2ItemWidget from "@/components/itemV2/itemV2ItemWidget.vue";
import ItemV3Engraving from "@/components/itemV3/parameter/itemV3Engraving.vue";
import {Config} from "@/assets/ts/config";

const pageStr = "components.itemV2.itemV2Main"

declare global {
  interface Window {
    addLastSeen?: (itemNumber: string, image: string, linkItemNumber: string) => void
  }
}


declare global {
  interface Window {
    addWishlist?: (itemNumber: string, image: string, linkItemNumber: string) => void,
    removeWishlist?: (linkItemNumber: string) => void,
    hasWishlist?: (linkItemNumber: string) => boolean
  }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV2Main',
  setup(__props) {

const store = useStore();
const {t} = useI18n();
const route = useRoute();
const router = useRouter();
const error = ref(0);

const session = ref(store.getters["session/get"]);

const itemIdx = computed({
  get: () => store.getters["session/getItemIdx"],
  set: (val) => store.commit("session/setItemIdx", val)
});
const activeWidget = ref("step");
const popupImage = ref(false);
const showEngraving = ref(false);

// Whether the current item is a wedding ring - wedding rings always use the itemV3
// variants configurator and engraving components; other item types use the itemV2 ones.
const isWeddingRing = computed(() => session.value.items[itemIdx.value]?.facts?.item_type === 'wedding_ring');

const configureAll = computed(() => store.getters["session/getConfigureAll"]);

// For wedding rings, show the description/details of all items (the pair); otherwise only the current item.
const descriptionItems = computed(() => {
  const currentItem = session.value.items[itemIdx.value];
  if (!currentItem) return [];

  const toDescriptionItem = (item: any) => ({
    itemPrice: item.price,
    itemNumber: item.item_number,
    description: item.desc.title,
    partsList: item.desc.parts,
  });

  if (isWeddingRing.value && session.value.items.length > 1) {
    return session.value.items.map(toDescriptionItem);
  }

  return [toDescriptionItem(currentItem)];
});

const setPrice = computed(() => {
  let total = 0;
  if (session.value.items) {
    for (const item of session.value.items) {
      total += item.price?.total || 0;
    }
  }
  return total;
});
const hoveredVariantImage = ref<any>(null);
const mainContainer = ref<HTMLElement | null>(null);
const engravingEl = ref<any | null>(null);
const viewMode = computed({
  get: () => store.getters["session/getViewMode"],
  set: (val) => store.commit("session/setViewMode", val)
});

const mainImage = computed(() => {
  const currentItem = session.value.items[itemIdx.value];
  if (!currentItem) return null;


  if (currentItem.facts.item_type === 'wedding_ring') {
    let additionalItem = {}

    const pairItemIdx = (itemIdx.value == 0) ? 1 : 0;

    if (pairItemIdx >= 0 && pairItemIdx < session.value.items.length) {
      additionalItem = session.value.items[pairItemIdx].image
    }

    return {
      ...currentItem.image,
      additionalItem: additionalItem,
      set: session.value.set
    };
  }

  if (hoveredVariantImage.value) {
    const img = hoveredVariantVariantImage(hoveredVariantImage.value);
    return {
      ...currentItem.image,
      filename: img.filename,
      filename_layer: img.filename_layer,
    };
  }
  return currentItem.image;
});

const hoveredVariantVariantImage = (img: any) => {
  return {
    filename: typeof img === 'string' ? img : (img?.filename || ''),
    filename_layer: typeof img === 'object' ? (img?.filename_layer || '') : '',
  };
};

// Initialize from route/config
const parsedItemIdx = typeof route.params.itemIdx === 'string'
    ? parseInt(route.params.itemIdx, 10)
    : (typeof route.params.itemIdx === 'number' ? route.params.itemIdx : 0);
itemIdx.value = isNaN(parsedItemIdx as number) ? 0 : (parsedItemIdx as number);

if (Config.getViewMode() != '') {
  viewMode.value = Config.getViewMode()
}

watch(itemIdx, (newValue, oldValue) => {
  if (oldValue != newValue) {
    scrollUp()
  }
})

// When engraving section becomes visible, scroll it into view
watch(showEngraving, async (visible) => {
  if (!visible) return;
  await nextTick();
  const el = (engravingEl.value as any)?.$el ?? (engravingEl.value as any);
  if (el && typeof el.scrollIntoView === 'function') {
    el.scrollIntoView({behavior: 'smooth', block: 'end'});
  }
});

const sessionsObj: Sessions = new Sessions();

const scrollUp = (): void => {
  const element = mainContainer.value;
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

const handleKeydown = (e: KeyboardEvent) => {
  if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
    e.preventDefault();
    printout();
  }
};

onMounted(() => {
  // item loading handled by child component IntersectionObservers
  window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown);
});

if (session.value.session_id !== route.params.sessionId) {
  store.commit("loading/actionStarted");

  sessionsObj
      .get(route.params.sessionId.toString())
      .then((sessionData: any) => {
        store.commit("loading/actionFinished");
        if (typeof sessionData.error != "undefined") {
          error.value = sessionData.error;
        } else {
          store.commit("session/setFull", sessionData);
          session.value = store.getters["session/get"];
          checkItemIsOnWishlist();

          setPageTitle()
          setLastSeen();
        }
      });
}

// Watch for route sessionId changes and reload the session when it changes
watch(
    () => route.params.sessionId,
    async (newSessionId, oldSessionId) => {
      if (!newSessionId || newSessionId === oldSessionId) return;

      store.commit("loading/actionStarted");
      try {
        const sessionData: any = await sessionsObj.get(newSessionId.toString());
        store.commit("loading/actionFinished");
        if (typeof sessionData.error !== "undefined") {
          error.value = sessionData.error;
          return;
        }
        // Update store and local refs
        store.commit("session/setFull", sessionData);
        session.value = store.getters["session/get"];

        // Reset indices safely based on current route
        const parsedIdx = typeof route.params.itemIdx === 'string'
            ? parseInt(route.params.itemIdx, 10)
            : (typeof route.params.itemIdx === 'number' ? route.params.itemIdx : 0);
        itemIdx.value = isNaN(parsedIdx as number) ? 0 : (parsedIdx as number);
        imageIdx.value = '-1';

        checkItemIsOnWishlist();
        setPageTitle();
        setLastSeen();
      } catch (e) {
        // Ensure loading state is cleared even on unexpected errors
        store.commit("loading/actionFinished");
        // Optionally log or set a generic error
        // console.error(e);
      }
    }
);

/**
 * set last seen
 */

const setLastSeen = () => {
  if (window?.addLastSeen) {
    window.addLastSeen?.(
        session.value.session_id,
        `https://items.api.rubin-trauringe.de/images/session/${session.value.session_id}`,
        window.location.href
    )
  }
}

/**
 * wishlist
 */

const wishListLinkItemNumber = computed(() => {
      if (session.value?.items[itemIdx.value as string]) {
        return window.location.origin + window.location.pathname + "#/?add=" + session.value.items[itemIdx.value as string].item_number
      } else {
        return ""
      }
    }
)

const addToWishList = () => {
  const itemNumber = session.value.items[itemIdx.value as string].item_number
  const image = `https://items.api.rubin-trauringe.de/image/${session.value.items[itemIdx.value as string].item_number}/main`
  const linkItemNumber = wishListLinkItemNumber.value

  console.debug("addToWishList", itemNumber, image, linkItemNumber)

  if (window?.addWishlist) {
    window?.addWishlist(itemNumber, image, linkItemNumber)
    isOnWishlist.value = true
  }
  isOnWishlist.value = true
}

const checkItemIsOnWishlist = () => {
  isOnWishlist.value = window?.hasWishlist ? window?.hasWishlist(wishListLinkItemNumber.value) : false
}

const isOnWishlist = ref(false)

const toggleItemOnWishList = () => {
  if (isOnWishlist.value) {
    if (window?.removeWishlist) {
      console.debug("removeFromWishlist", wishListLinkItemNumber.value)
      window?.removeWishlist(wishListLinkItemNumber.value)
      isOnWishlist.value = false
    }
  } else (
      addToWishList()
  )
}

const isSecureConftecHost = computed(() => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname.includes('ringfabrik.de') || hostname.includes('localhost');
});

/**
 * Set page title
 */

const setPageTitle = () => {
  if (typeof session.value.items[itemIdx.value] !== "undefined") {
    document.title = session.value.items[itemIdx.value].desc.title
  } else {
    document.title = t(pageStr + '.configurator')
  }

}

/**
 *
 */

const imageIdx = ref('-1');
watch(imageIdx, () => {
  scrollUp();
}, {flush: 'post'});

/**
 * order data
 */

const b64EncodeUnicode = (str: string) => {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
        return String.fromCharCode('0x' + p1);
      }));
}

const orderData = ref("");
const orderForm = ref(null);

const createOrder = () => {
  store.commit("loading/actionStarted");

  sessionsObj
      .get_order_data(session.value.session_id)
      .then((tmpOrderData: any) => {
        if (typeof tmpOrderData.error != "undefined") {
          error.value = tmpOrderData.error;
        } else {
          orderData.value = b64EncodeUnicode(JSON.stringify(tmpOrderData));

          setTimeout(() => {
            orderForm.value?.submit();
          }, 100);
          store.commit("loading/actionFinished");
        }
      });
};

const printout = () => {
  const sid = session.value.session_id;
  if (!sid) return;
  // Use vue-router to resolve the hash URL, then open in a new window/tab
  const routeLocation = router.resolve({name: 'ConfigurationPrintout', params: {sessionId: sid}});
  window.open(routeLocation.href, '_blank');
};

const onShare = async () => {
  try {
    const curItem = session.value?.items?.[itemIdx.value];
    const title = curItem?.desc?.title || curItem?.desc?.short_title || t(pageStr + '.share_configuration');
    const text = t(pageStr + '.check_out_this_configuration');
    const url = window.location?.href || '';

    if (typeof navigator !== 'undefined' && 'share' in navigator) {
      // @ts-ignore - Web Share API may not be in TS lib
      await navigator.share({title, text, url});
      return;
    }

    // Fallback: copy URL to clipboard
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      alert(t(pageStr + '.link_copied_to_clipboard'));
      return;
    }

    // Last-resort fallback
    const tmp = document.createElement('input');
    tmp.value = url;
    document.body.appendChild(tmp);
    tmp.select();
    document.execCommand('copy');
    document.body.removeChild(tmp);
    alert(t(pageStr + '.link_copied_to_clipboard'));
  } catch (e) {
    // Swallow errors; optionally inform the user
  }
};

const loadingVariants = new Set<string>();

const loadItemVariants = async (idx: number, variantIdx?: string, variantIdxAddon: string = "") => {
  if (!session.value || !session.value.items || !session.value.items[idx]) return;
  const item = session.value.items[idx];
  const sessionId = session.value.session_id;

  if (!item.variants) return;

  const variantsToLoad = variantIdx
      ? item.variants.filter((v: any) => v.idx === variantIdx)
      : item.variants;

  const valuePromises = variantsToLoad.map((variant: any) => {

    const key = `${idx}-${variant.idx}`;
    if ((variant.values && variant.values.length > 0) || loadingVariants.has(key)) return Promise.resolve();

    loadingVariants.add(key);
    return sessionsObj.getVariantValues(sessionId, idx, variant.idx, variantIdxAddon)
        .then((data: any) => {
          if (typeof data.error != 'undefined') {
            store.commit("session/removeVariant", {
              itemIdx: idx,
              variantIdx: variant.idx
            });
            session.value = store.getters["session/get"];
            return;
          }


          const isWeddingRing = item.facts?.item_type === 'wedding_ring';
          const isAddOrRemove = variant.idx && (variant.idx.includes('add') || variant.idx.includes('remove'));
          // discs.<n>.width must be kept even with a single value: it's not a real choice
          // but the marker itemV2DiscWidthConfigurator.vue relies on to know the disc exists
          // and to display its current width - this matters most for single-disc rings,
          // where there is often only one possible width value.
          const isDiscWidth = variant.idx && /^discs\.\d+\.width$/.test(variant.idx);
          // discs.<n>.metal/color/finish and grooves.<n>.metal/color/finish must likewise be
          // kept even with a single (fixed, non-selectable) value: itemV2DiscWidthConfigurator.vue
          // and itemV2GrooveConfigurator.vue both rely on the matched value to render the actual
          // disc/groove color in the ring cross-section - without this exemption, that single value
          // is discarded right after being fetched and the cross-section falls back to a generic color.
          const isDiscOrGrooveColorSwatch = variant.idx && /^(discs|grooves)\.\d+\.(metal|color|finish)$/.test(variant.idx);
          // Fixed stone values still describe the preset and its read-only groups.
          const isStoneDisplayVariant = variant.idx && /^stones\.(stone_presets|\d+\.[^.]+)$/.test(variant.idx);
          const keepIfOneValue = isWeddingRing && (isAddOrRemove || isDiscWidth || isDiscOrGrooveColorSwatch || isStoneDisplayVariant) && data.values && data.values.length === 1;

          if (!data.values || (data.values.length < 2 && !keepIfOneValue)) {
            store.commit("session/removeVariant", {
              itemIdx: idx,
              variantIdx: variant.idx
            });
          } else {
            store.commit("session/setVariantValues", {
              itemIdx: idx,
              variantIdx: variant.idx,
              values: data.values
            });
          }
          session.value = store.getters["session/get"];
        })
        .catch(err => {
          console.error(`Failed to load values for variant ${variant.idx}`, err);
          // If variant not found or invalid item index, re-fetch the whole session to refresh stubs
          const errorMsg = err.message || err.error || "";
          const isRefreshError = typeof errorMsg === 'string' && (errorMsg.includes("not found") || errorMsg.includes("index"));

          if (isRefreshError) {
            sessionsObj.get(sessionId).then((sessionData: any) => {
              store.commit("session/setFull", sessionData);
              session.value = store.getters["session/get"];
            });
          } else {
            // If status != 200 remove the variant from the variants list
            store.commit("session/removeVariant", {
              itemIdx: idx,
              variantIdx: variant.idx
            });
            session.value = store.getters["session/get"];
          }

        })
        .finally(() => {
          loadingVariants.delete(key);
        });
  });
  Promise.allSettled(valuePromises);
}

provide("loadItemVariants", loadItemVariants);
provide("itemIdx", itemIdx);
provide("session", session);

// Applies a distinct action/value pair per item in a single request (see Sessions.patchMultiple),
// used e.g. by itemV3StonePresets.vue to apply a stone preset to one item while forcing "no
// stones" on the other items of a set, independent of the global configureAll setting.
// showLoading can be set to false for patches that happen while the user is still actively
// interacting with a field (e.g. typing an engraving text or adding engraving symbols), so the
// full-screen loading animation doesn't block the field and interrupt the user's input.
const patchMultiple = (items: { itemIdx: number, action: string, value: string }[], showLoading = true) => {
  if (showLoading) {
    store.commit("loading/actionStarted");
  }
  sessionsObj.patchMultiple(session.value.session_id, items).then((sessionData: any) => {
    if (showLoading) {
      store.commit("loading/actionFinished");
    }
    if (typeof sessionData.error != "undefined") {
      error.value = sessionData.error;
    } else {
      store.commit("session/setFull", sessionData);
      session.value = store.getters["session/get"];
    }
  });
};

provide("patchMultiple", patchMultiple);

// When set-view (configureAll) is active, a patch is applied to every item of the session
// at once, sent as a list to the same PATCH endpoint (see Sessions.patchSet). Pass
// forceSingleItem=true for patches that are inherently individual per item (e.g. name,
// engraving) and must never be applied to the whole set.
const patch = (action: string, value: any, certificatedDiamond: boolean, forceSingleItem = false) => {
  store.commit("loading/actionStarted");

  const applyToWholeSet = !forceSingleItem && configureAll.value && session.value.items.length > 1;

  const apiCall = applyToWholeSet
      ? sessionsObj.patchSet(
          session.value.session_id,
          value,
          session.value.items.map((_: any, idx: number) => ({itemIdx: idx, valueIdx: action}))
      )
      : sessionsObj.patch(session.value.session_id, itemIdx.value, action, value);

  apiCall.then((sessionData: any) => {
    store.commit("loading/actionFinished");
    if (typeof sessionData.error != "undefined") {
      error.value = sessionData.error;
    } else {
      //if (sessionData.item_idx !== -1) {
      //itemIdx.value = sessionData.item_idx;
      //}
      store.commit("session/setFull", sessionData);
      session.value = store.getters["session/get"];
    }
  });
};

const deleteItem = (idx: number) => {
  store.commit("loading/actionStarted");
  sessionsObj
      .deleteItem(session.value.session_id, idx)
      .then((sessionData: any) => {
        store.commit("loading/actionFinished");
        if (typeof sessionData.error != "undefined") {
          error.value = sessionData.error;
        } else {
          const newItemsLength = sessionData.items?.length || 0;
          if (itemIdx.value >= newItemsLength) {
            itemIdx.value = Math.max(0, newItemsLength - 1);
          }
          store.commit("session/setFull", sessionData);
          session.value = store.getters["session/get"];
        }
      })
      .catch((err) => {
        store.commit("loading/actionFinished");
        console.error("Failed to delete item:", err);
        alert(t('components.itemV2.itemV2ItemWidget.error_deleting'));
      });
};

const addItem = (idx: number) => {
  store.commit("loading/actionStarted");
  sessionsObj
      .addItem(session.value.session_id, idx)
      .then((sessionData: any) => {
        store.commit("loading/actionFinished");
        if (typeof sessionData.error != "undefined") {
          error.value = sessionData.error;
        } else {
          store.commit("session/setFull", sessionData);
          session.value = store.getters["session/get"];
          itemIdx.value = idx;
          store.commit("session/setConfigureAll", true);
        }
      })
      .catch((err) => {
        store.commit("loading/actionFinished");
        console.error("Failed to add item:", err);
        alert(t('components.itemV2.itemV2ItemWidget.error_adding'));
      });
};

const patchSet = (value: string, items: { itemIdx: number, valueIdx: string }[]) => {
  store.commit("loading/actionStarted");
  sessionsObj
      .patchSet(session.value.session_id, value, items)
      .then((sessionData: any) => {
        store.commit("loading/actionFinished");
        if (typeof sessionData.error != "undefined") {
          error.value = sessionData.error;
        } else {
          store.commit("session/setFull", sessionData);
          session.value = store.getters["session/get"];
        }
      });
}

const currentColor = computed(() => {
  // search on root level
  for (let variantIdx in session.value.items[0].variants) {
    if (session.value.items[0].variants[variantIdx].idx === "color") {
      const variantData = session.value.items[0].variants[variantIdx];
      for (let valueIdx in variantData.values) {
        if (variantData.values[valueIdx].match === true) {
          return variantData.values[valueIdx].idx.toLowerCase();
        }
      }
    }
  }
  // search alternativ
  for (let variantIdx in session.value.items[0].variants) {
    if (session.value.items[0].variants[variantIdx].idx?.includes("color")) {
      const variantData = session.value.items[0].variants[variantIdx];
      for (let valueIdx in variantData.values) {
        if (variantData.values[valueIdx].match === true) {
          return variantData.values[valueIdx].idx.toLowerCase();
        }
      }
    }
  }
  return "";
});

/**
 * Diamantbörse
 */

const addCertificatedDiamond = () => {
  let baseUrl = "/"

  if (window.__CONFIGURATOR_PROPS__) {
    baseUrl = window.__CONFIGURATOR_PROPS__.baseUrl
  }

  window.location.href = baseUrl + session.value.session_id + "/diamonds";
};

const isDiamondExchangeUsable = computed(() => {
  return session.value.items[parseInt(itemIdx.value.toString())]?.facts.biggest_stone >= 0.3
})

/**
 * Stone types
 */

const getStoneTypes = computed(() => {
  const stoneTypes = []
  if (session.value.items[itemIdx.value]?.variants) {
    for (const variantsIdx in session.value.items[itemIdx.value]?.variants) {
      const variantsData = session.value.items[itemIdx.value]?.variants[variantsIdx]
      if (variantsData?.idx?.includes("stone_type")) {
        stoneTypes.push(variantsData)
      }
    }
  }
  return stoneTypes
})

/**
 * view mode
 */

const showStepWidget = () => {
  nextTick(() => {
    activeWidget.value = 'step'
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "mainContainer",
    ref: mainContainer
  }, [
    _createElementVNode("div", _hoisted_1, [
      (activeWidget.value === 'items' && (isWeddingRing.value || session.value.items.length > 1))
        ? (_openBlock(), _createBlock(ItemV2ItemWidget, {
            key: 0,
            session: session.value,
            onShowStepWidget: showStepWidget,
            onDeleteItem: deleteItem
          }, null, 8, ["session"]))
        : (isWeddingRing.value)
          ? (_openBlock(), _createBlock(StepWidgetConf, {
              key: 1,
              session: session.value,
              "item-idx": itemIdx.value,
              onDeleteItem: deleteItem,
              onAddItem: addItem
            }, null, 8, ["session", "item-idx"]))
          : (_openBlock(), _createBlock(StepWidget, {
              key: 2,
              show: session.value.items[itemIdx.value]?.diamond_exchange
            }, {
              default: _withCtx(() => [
                (session.value.items.length > 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (activeWidget.value = 'items')),
                      class: "flex items-center space-x-2 cursor-pointer h-full px-4 border-r border-gray-100 hover:bg-gray-50 transition-colors"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(session.value.items, (item, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.item_number || idx,
                          class: _normalizeClass(["w-8 h-8 lg:w-10 lg:h-10 rounded-full border border-gray-200 overflow-hidden bg-white shrink-0 relative", {'ring-2 ring-brand-main': itemIdx.value == idx}])
                        }, [
                          (item.image.filename_layer)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: item.image.filename_layer,
                                class: "absolute insert-0 w-auto h-full aspect-square object-cover",
                                alt: "Setting image"
                              }, null, 8, _hoisted_2))
                            : _createCommentVNode("", true),
                          _createElementVNode("img", {
                            src: item.image.filename,
                            class: "w-full h-full object-cover",
                            alt: ""
                          }, null, 8, _hoisted_3)
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["show"])),
      (viewMode.value == 'set')
        ? (_openBlock(), _createBlock(ItemV2ShopTheLook, {
            key: 3,
            session: session.value,
            onPatchSet: _cache[1] || (_cache[1] = (event) => patchSet(event.value, event.items))
          }, null, 8, ["session"]))
        : (viewMode.value == 'item' && session.value.items && session.value.items[itemIdx.value])
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["z-30 top-0 flex-2", {'sticky': !isWeddingRing.value}])
                }, [
                  (isWeddingRing.value)
                    ? (_openBlock(), _createBlock(ItemV3ImageGridWeddingRings, {
                        key: 0,
                        class: "sticky z-40 top-0 bg-white aspect-4/3 lg:aspect-auto lg:h-auto",
                        image: mainImage.value,
                        "item-number": session.value.items[itemIdx.value].item_number,
                        "image-idx": imageIdx.value,
                        "popup-image": popupImage.value,
                        onSwitchImage: _cache[2] || (_cache[2] = (event) => imageIdx.value = event),
                        onPopupImage: _cache[3] || (_cache[3] = (event) => popupImage.value = event)
                      }, null, 8, ["image", "item-number", "image-idx", "popup-image"]))
                    : (_openBlock(), _createBlock(ItemV2ImageGrid, {
                        key: 1,
                        class: "sticky z-40 top-0 bg-white aspect-4/3 lg:aspect-auto lg:h-auto",
                        image: mainImage.value,
                        "item-number": session.value.items[itemIdx.value].item_number,
                        engraving: session.value.engravings[itemIdx.value].inside,
                        "image-idx": imageIdx.value,
                        "popup-image": popupImage.value,
                        onSwitchImage: _cache[4] || (_cache[4] = (event) => imageIdx.value = event),
                        onPopupImage: _cache[5] || (_cache[5] = (event) => popupImage.value = event)
                      }, null, 8, ["image", "item-number", "engraving", "image-idx", "popup-image"])),
                  _createElementVNode("div", _hoisted_6, [
                    ((configureAll.value ? setPrice.value : session.value.items[itemIdx.value].price.total) > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$n(configureAll.value ? setPrice.value : session.value.items[itemIdx.value].price.total, "currency")), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _createElementVNode("ul", _hoisted_8, [
                        _createElementVNode("li", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (imageIdx.value = '-1')),
                          class: "py-2 px-1"
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["border-gray-900 rounded-full w-3 h-3 border", {
                'bg-gray-900': imageIdx.value == '-1',
                  }])
                          }, null, 2)
                        ]),
                        (session.value.engravings[itemIdx.value].inside.text != '')
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 0,
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (imageIdx.value = 'Engraving')),
                              class: "py-2 px-1"
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["border-gray-900 rounded-full w-3 h-3 border", {
                'bg-gray-900': imageIdx.value == 'Engraving',
                  }])
                              }, null, 2)
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(session.value.items[itemIdx.value].image.positions, (image_pos, image_pos_idx) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: image_pos.filename,
                            onClick: ($event: any) => (imageIdx.value = image_pos_idx.toString()),
                            class: "py-2 px-1"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["border-gray-900 rounded-full w-3 h-3 border", {
                'bg-gray-900': imageIdx.value == image_pos_idx.toString(),
                  }])
                            }, null, 2)
                          ], 8, _hoisted_9))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (popupImage.value=true)),
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        "stroke-width": "1.5",
                        stroke: "currentColor",
                        class: "w-5 pt-0.5 cursor-pointer mr-4"
                      }, [...(_cache[25] || (_cache[25] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
                        }, null, -1)
                      ]))])),
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: onShare,
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        "stroke-width": "1.5",
                        stroke: "currentColor",
                        class: "w-5 pt-0.5 cursor-pointer mr-4",
                        "aria-label": _ctx.$t(pageStr + '.share'),
                        role: "button"
                      }, [...(_cache[26] || (_cache[26] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                        }, null, -1)
                      ]))], 8, _hoisted_11)),
                      (!isOnWishlist.value)
                        ? (_openBlock(), _createElementBlock("svg", {
                            key: 0,
                            onClick: toggleItemOnWishList,
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            "stroke-width": "1.5",
                            stroke: "currentColor",
                            class: "w-6 cursor-pointer text-brand-text"
                          }, [...(_cache[27] || (_cache[27] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                            }, null, -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("svg", {
                            key: 1,
                            onClick: toggleItemOnWishList,
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "currentColor",
                            viewBox: "0 0 24 24",
                            "stroke-width": "1.5",
                            stroke: "currentColor",
                            class: "w-6 cursor-pointer text-brand-text"
                          }, [...(_cache[28] || (_cache[28] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                            }, null, -1)
                          ]))]))
                    ])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex-1 md:min-w-[480px] md:px-4 space-y-4 md:pt-0 z-10 pb-4", { 'bg-parameter-bg': isWeddingRing.value }])
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["px-4 flex flex-col justify-center top-0 z-40 pt-2 pb-2", {'bg-parameter-bg': isWeddingRing.value, 'bg-white': !isWeddingRing.value}])
                    }, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(session.value.items[itemIdx.value].desc.short_title), 1),
                      _createElementVNode("div", _hoisted_14, [
                        ((configureAll.value ? setPrice.value : session.value.items[itemIdx.value].price.total) > 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$n(configureAll.value ? setPrice.value : session.value.items[itemIdx.value].price.total, "currency")), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t(pageStr + '.incl_vat')), 1),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            (_openBlock(), _createElementBlock("svg", {
                              onClick: onShare,
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              "stroke-width": "1.5",
                              stroke: "currentColor",
                              class: "w-6 mx-auto cursor-pointer",
                              "aria-label": _ctx.$t(pageStr + '.share'),
                              role: "button"
                            }, [...(_cache[29] || (_cache[29] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                              }, null, -1)
                            ]))], 8, _hoisted_19))
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            (!isOnWishlist.value)
                              ? (_openBlock(), _createElementBlock("svg", {
                                  key: 0,
                                  onClick: toggleItemOnWishList,
                                  xmlns: "http://www.w3.org/2000/svg",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  "stroke-width": "1.5",
                                  stroke: "currentColor",
                                  class: "w-6 cursor-pointer text-brand-main"
                                }, [...(_cache[30] || (_cache[30] = [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                                  }, null, -1)
                                ]))]))
                              : (_openBlock(), _createElementBlock("svg", {
                                  key: 1,
                                  onClick: toggleItemOnWishList,
                                  xmlns: "http://www.w3.org/2000/svg",
                                  fill: "currentColor",
                                  viewBox: "0 0 24 24",
                                  "stroke-width": "1.5",
                                  stroke: "currentColor",
                                  class: "w-6 cursor-pointer text-brand-main"
                                }, [...(_cache[31] || (_cache[31] = [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                                  }, null, -1)
                                ]))]))
                          ])
                        ])
                      ]),
                      false
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[32] || (_cache[32] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              "stroke-width": "1.5",
                              stroke: "currentColor",
                              class: "w-7 pt-0.5 cursor-pointer hover:text-brand-main"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                              })
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ], 2),
                    (session.value.items[itemIdx.value].facts.item_type !== 'wedding_ring')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createVNode(ItemV2StoneType, {
                            "stone-types": getStoneTypes.value,
                            onPatch: _cache[9] || (_cache[9] = (event) => patch(event.action, event.value, event.certificated_diamond))
                          }, null, 8, ["stone-types"])
                        ]))
                      : _createCommentVNode("", true),
                    (showEngraving.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("div", {
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (showEngraving.value = false)),
                            class: "flex items-center cursor-pointer w-full"
                          }, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t(pageStr + '.article_configuration')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              (_openBlock(), _createElementBlock("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: _normalizeClass(["w-4 h-4 transition-transform duration-300", { 'rotate-180': !showEngraving.value }]),
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [...(_cache[33] || (_cache[33] = [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 9l-7 7-7-7"
                                }, null, -1)
                              ]))], 2))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!showEngraving.value && session.value.items[itemIdx.value].facts.item_type === 'wedding_ring')
                      ? (_openBlock(), _createBlock(ItemV3VariantsConf, {
                          key: 2,
                          "item-idx": itemIdx.value,
                          item: session.value.items[itemIdx.value],
                          "session-id": session.value.session_id,
                          onPatch: _cache[11] || (_cache[11] = (event) => patch(event.action, event.value, event.certificated_diamond)),
                          onHover: _cache[12] || (_cache[12] = (image) => hoveredVariantImage.value = image)
                        }, null, 8, ["item-idx", "item", "session-id"]))
                      : (!showEngraving.value)
                        ? (_openBlock(), _createBlock(ItemV2Variants, {
                            key: 3,
                            item: session.value.items[itemIdx.value],
                            "item-idx": itemIdx.value,
                            "session-id": session.value.session_id,
                            onPatch: _cache[13] || (_cache[13] = (event) => patch(event.action, event.value, event.certificated_diamond))
                          }, null, 8, ["item", "item-idx", "session-id"]))
                        : _createCommentVNode("", true),
                    (session.value.items[itemIdx.value].engraving)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          (!isWeddingRing.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("div", {
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (showEngraving.value = !showEngraving.value)),
                                  class: "flex items-center cursor-pointer w-full"
                                }, [
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t(pageStr + '.engraving')), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    (_openBlock(), _createElementBlock("svg", {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      class: _normalizeClass(["w-4 h-4 transition-transform duration-300", { 'rotate-180': showEngraving.value }]),
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }, [...(_cache[34] || (_cache[34] = [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M19 9l-7 7-7-7"
                                      }, null, -1)
                                    ]))], 2))
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (showEngraving.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                ref_key: "engravingEl",
                                ref: engravingEl,
                                class: "mt-4"
                              }, [
                                _createVNode(ItemV2Engraving, {
                                  engraving: session.value.engravings[itemIdx.value].inside,
                                  "onUpdate:engraving": _cache[15] || (_cache[15] = (event) => session.value.engravings[itemIdx.value].inside = event),
                                  onPatch: _cache[16] || (_cache[16] = (event) => patch(event.action, event.value, event.certificated_diamond, true)),
                                  "onSwitch:image": _cache[17] || (_cache[17] = (event) => imageIdx.value = event.toString())
                                }, null, 8, ["engraving"])
                              ], 512))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_31, [
                      (!isWeddingRing.value)
                        ? (_openBlock(), _createBlock(ItemV2Name, {
                            key: 0,
                            onPatch: _cache[18] || (_cache[18] = (event) => patch(event.action, event.value, event.certificated_diamond, true))
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      (session.value.items[itemIdx.value].diamond_exchange)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            (!isDiamondExchangeUsable.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t(pageStr + '.select_stone_from_diamond_exchange_inactive')), 1))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light",
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (addCertificatedDiamond()))
                                }, _toDisplayString(_ctx.$t(pageStr + '.select_stone_from_diamond_exchange')), 1))
                          ]))
                        : _createCommentVNode("", true),
                      false
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "cursor-pointer block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => {viewMode.value = 'set'; itemIdx.value = 0})
                          }, _toDisplayString(_ctx.$t(pageStr + '.complete_your_look')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("a", _hoisted_35, _toDisplayString(_ctx.$t(pageStr + '.consult_at_location')), 1),
                      _createElementVNode("a", {
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (printout())),
                        class: "cursor-pointer block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
                      }, _toDisplayString(_ctx.$t(pageStr + '.printout')), 1),
                      (_unref(Config).getShopUrl() !== '')
                        ? (_openBlock(), _createElementBlock("form", {
                            key: 2,
                            method: "post",
                            action: _unref(Config).getShopUrl(),
                            target: "_blank",
                            ref_key: "orderForm",
                            ref: orderForm
                          }, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (createOrder())),
                              class: "block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
                            }, [
                              (_unref(Config).getShopUrlButtonText() !== '')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_unref(Config).getShopUrlButtonText()), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t(pageStr + '.dealer_login')), 1)
                                  ], 64))
                            ]),
                            _cache[35] || (_cache[35] = _createElementVNode("input", {
                              type: "hidden",
                              name: "lang",
                              value: "de"
                            }, null, -1)),
                            _cache[36] || (_cache[36] = _createElementVNode("input", {
                              type: "hidden",
                              name: "action",
                              value: "order"
                            }, null, -1)),
                            _createElementVNode("input", {
                              type: "hidden",
                              name: "order",
                              value: orderData.value
                            }, null, 8, _hoisted_37)
                          ], 8, _hoisted_36))
                        : (session.value.items[itemIdx.value].item_number.includes('R-'))
                          ? (_openBlock(), _createElementBlock("form", {
                              key: 3,
                              method: "post",
                              action: "https://www.rubin-ec84.de:7004/store/faces/login.xhtml",
                              target: "_blank",
                              ref_key: "orderForm",
                              ref: orderForm
                            }, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[23] || (_cache[23] = ($event: any) => (createOrder())),
                                class: "block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
                              }, _toDisplayString(_ctx.$t(pageStr + '.dealer_login')), 1),
                              _cache[37] || (_cache[37] = _createElementVNode("input", {
                                type: "hidden",
                                name: "lang",
                                value: "de"
                              }, null, -1)),
                              _cache[38] || (_cache[38] = _createElementVNode("input", {
                                type: "hidden",
                                name: "action",
                                value: "order"
                              }, null, -1)),
                              _createElementVNode("input", {
                                type: "hidden",
                                name: "order",
                                value: orderData.value
                              }, null, 8, _hoisted_38)
                            ], 512))
                          : (session.value.items[itemIdx.value].item_number.includes('S-') && isSecureConftecHost.value)
                            ? (_openBlock(), _createElementBlock("form", {
                                key: 4,
                                method: "post",
                                action: "https://secure.conftec.com/order/sales/site_index.php",
                                target: "_blank",
                                ref_key: "orderForm",
                                ref: orderForm
                              }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[24] || (_cache[24] = ($event: any) => (createOrder())),
                                  class: "block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
                                }, _toDisplayString(_ctx.$t(pageStr + '.dealer_login')), 1),
                                _cache[39] || (_cache[39] = _createElementVNode("input", {
                                  type: "hidden",
                                  name: "lang",
                                  value: "de"
                                }, null, -1)),
                                _cache[40] || (_cache[40] = _createElementVNode("input", {
                                  type: "hidden",
                                  name: "action",
                                  value: "order"
                                }, null, -1)),
                                _createElementVNode("input", {
                                  type: "hidden",
                                  name: "order",
                                  value: orderData.value
                                }, null, 8, _hoisted_39)
                              ], 512))
                            : _createCommentVNode("", true)
                    ])
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(DescriptionParts, { items: descriptionItems.value }, null, 8, ["items"])
              ])
            ]))
          : _createCommentVNode("", true)
    ])
  ], 512))
}
}

})